import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	carouselPageCount: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	carouselPageCount: {
		id: 'version-issue-associated-designs.design-carousel.carousel-page-count',
		defaultMessage: '{currentStart}-{currentEnd} of {totalCount}',
		description: 'The page indicator of the design card carousel.',
	},
});
export default messages;
